import type { ReactNode, VoidFunctionComponent } from 'react';

import styles from './InventoryViewHeader.module.less';

type Props = {
  title: string;
  label?: ReactNode;
};

const InventoryViewHeader: VoidFunctionComponent<Props> = ({ title, label }) => (
  <header className={styles.header}>
    <h1 className={styles.title}>{title}</h1>
    {label && <div className={styles.label}>{label}</div>}
  </header>
);

export { InventoryViewHeader };
